import { type Action, type ThunkDispatch } from '@reduxjs/toolkit';

import { initializeWalletsAsync } from '@app/store/zustand';

import { type RootState } from '../reducers';
import { type WebsocketMessage, WebsocketTopic } from '../types/websockets';

import { setNewVersionAvailable } from './dashboard';
import { getCartItems } from './picker';
import { getCurrentUserEmojis } from './user-emojis';

export function handleMessage(message: MessageEvent) {
    return async function (dispatch: ThunkDispatch<RootState, void, Action>): Promise<void> {
        try {
            const websocketMessage: WebsocketMessage = JSON.parse(message.data);
            const { topic } = websocketMessage;

            switch (topic) {
                case WebsocketTopic.AppRelease:
                    dispatch(setNewVersionAvailable(true));
                    window.location.reload();
                    break;
                case WebsocketTopic.EmojiTransferRequestAccepted:
                case WebsocketTopic.WalletConnected:
                    void dispatch(getCurrentUserEmojis());
                    break;
                case WebsocketTopic.MultipleNftsAdded:
                case WebsocketTopic.MultipleNftsRemoved:
                case WebsocketTopic.NftAdded:
                case WebsocketTopic.NftRemoved:
                    void initializeWalletsAsync();
                    break;
                case WebsocketTopic.Notification:
                    // Add actions to use dispatch and payload
                    break;
                case WebsocketTopic.OrderUpdated: {
                    await dispatch(getCartItems());
                    break;
                }
                default:
                    // eslint-disable-next-line no-console
                    console.log(`Unsupported topic`, topic);
            }
        } catch (error) {
            // Invalid websocket data
            // eslint-disable-next-line no-console
            console.error(error);
        }
        return;
    };
}
